// @flow

// Libraries
import React, { Element, useState } from 'react';
import classNames from 'classnames';
import { Link, useHistory } from 'react-router-dom';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import { get, isFunction } from 'lodash';

// Components
import AppBar from '@material-ui/core/AppBar';
import Container from '@material-ui/core/Container';
import Toolbar from '@material-ui/core/Toolbar';
import Icon from '@material-ui/core/Icon';

import Search from '@views/Search/Search';
import Button from '@components/Button';
import Sandwich from '@components/Sandwich/Sandwich';

import MainMenu from '../MainMenu/MainMenu';
import Logo from '../Logo';

import Favorites from './Favorites';
import Recent from './Recent';

// Data
// import {WYSIWYG_menu} from './menuCollections';

// Services
import { updateSession } from '@services/session';

// Styles
import styles from './Header.scss';

// Icons
import { ReactComponent as UserIcon } from '@assets/icons/user.svg';

// Types
type HeaderTypes = {
  className?: String,
  isHideNav?: Boolean,
  isLogin?: Boolean,
  isHasSandwich?: Boolean,
  isEdit?: Boolean,
  role?: string,
  updateSession?: Function,
  actionPanel?: any,
  onMode?: Function,
  menuItems?: Object
};

// eslint-disable-next-line complexity
const Header = ({
                  className,
                  isHideNav,
                  isLogin,
                  isHasSandwich,
                  isEdit,
                  role,
                  updateSession,
                  actionPanel,
                  onMode,
                  ...props
                }: HeaderTypes): Element<AppBar> => {
  const [isOpenSandwich, setOpenSandwich] = useState(false);
  const history = useHistory();
  // const menuItems = get(props, 'menuItems', MENU_ITEMS[isLogin ? 'login' : 'default']);
  const menuItemsVertical = get(props, 'menuItems.vertical', []);
  const menuItemsHorizontal = get(props, 'menuItems.horizontal', []);
  return (
    <AppBar
      position="static"
      color="transparent"
      elevation={0}
      data-is-login={isLogin}
      data-is-open-sandwich={isOpenSandwich}
      className={classNames(
        className,
        styles.Root,
        {
          [styles.RootWithShadow]: !isHideNav,
          [styles.RootCenteredLogo]: isHideNav
        }
      )}
    >
      <Container className={styles.Limiter} maxWidth="lg">
        <Toolbar classes={{ root: isLogin ? styles.ToolbarLogin : styles.Toolbar }} disableGutters>
          {
            isHasSandwich && (
              <Sandwich
                isOpenSandwich={isOpenSandwich}
                setOpenSandwich={setOpenSandwich}
              />
            )
          }
          {
            <Link to="./" className={styles.BrandPortalLogo}>Brand Portal</Link>
          }
          {
            <MainMenu
              classes={{
                root: classNames({
                  [styles.DesktopMenu]: true,
                  [styles.isLogin]: isLogin
                })
              }}
              items={menuItemsHorizontal}
              orientation="horizontal"
              isLogin={isLogin}
            />
          }
          {
            !isHideNav && (
              <div className={styles.Container}>
                {
                  isOpenSandwich && (
                    <>
                      <div
                        className={styles.BackgroundMobileMenu}
                        onClick={(): void => setOpenSandwich(false)}
                      />
                      <div
                        className={styles.ContainerMobileMenu}
                        onClick={(): void => setOpenSandwich(false)}
                      >
                        <MainMenu
                          classes={{ root: styles.MobileMenu }}
                          items={menuItemsVertical}
                          orientation="vertical"
                          isLogin={isLogin}
                        />
                      </div>
                    </>
                  )
                }
                {
                  actionPanel ? actionPanel : (
                    <>
                      {
                        isLogin && (
                          <>
                            {(role === 'admin' || role === 'editor') && (
                              <label
                                className={styles.EditMode}
                                htmlFor="edit_mode_checkbox"
                              >
                                <input
                                  id="edit_mode_checkbox"
                                  name="edit_mode"
                                  type="checkbox"
                                  checked={isEdit}
                                  onChange={(): void => updateSession({ isEdit: !isEdit }) && isFunction(onMode) && onMode(!isEdit)}
                                />
                                <i />
                                Edit mode
                              </label>
                            )}
                            {isLogin && (
                              <>
                                <Favorites />
                                <Recent />
                              </>
                            )}
                          </>
                        )
                      }
                      {isLogin ? (
                        <Button
                          size="small"
                          startIcon={<UserIcon className={styles.UserSignInIcon} />}
                          onClick={() => {
                            window.location = '/portal/profile';
                          }}
                          className={styles.UserProfile}
                        >
                          <span className={styles.ButtonText}>Profile</span>
                        </Button>
                      ) : (
                        <Button
                          size="small"
                          startIcon={<UserIcon className={styles.UserSignInIcon} />}
                          onClick={() => {
                            window.location = '/users/sign_in';
                          }}
                          className={styles.UserSignIn}
                        >
                          <span className={styles.ButtonText}>Sign in</span>
                        </Button>
                      )}
                    </>
                  )
                }
              </div>
            )
          }
        </Toolbar>
      </Container>
    </AppBar>
    // <div className={Menu.scss.Content}>
    //   <div className={Menu.scss.LeftSide}>
    //     <Logo />
    //     <Menu navList={WYSIWYG_menu} />
    //   </div>
    //   <div className={Menu.scss.RightSide}>2</div>
    // </div>
    // </div>
  );
};

const mapStateToProps = (state: Object): Object => ({
  isEdit: get(state, 'session.isEdit', false),
  isLogin: get(state, 'session.token', false),
  role: get(state, 'session.role', '')
});

const mapDispatchToProps = (dispatch) => ({
  // Services
  updateSession: (data) => dispatch(updateSession(data))
});

// Exports
export default compose(connect(mapStateToProps, mapDispatchToProps))(Header);
